<template>
  <div class="border-top">
    <!-- Row -->
    <div class="d-flex">
      <div class="col-4 py-2">{{ formattedDate }}</div>
      <div class="col-4 py-2">{{ amount }}</div>
      <div class="col-4 py-2">{{ status }}</div>
    </div>
    <!-- Pay Button -->
    <button v-if="canProcess"
      class="btn btn-secondary btn-block mb-3"
      type="button"
      @click="signalProcess">
      <i class="fas fa-shopping-cart"></i> Pay Now
    </button>
  </div>
</template>

<script>
import { PaymentRowMixin } from '@/mixins/Appointment/PaymentRowMixin'

export default {
  name: 'PaymentMobileRow',
  mixins: [PaymentRowMixin]
}
</script>
